exports = module.exports = require("../../node_modules/@angular/cli/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#footer {\n    background: #000000;\n    color: white;\n    width: 100%;\n}\n\n#footer-row {\n    background: #000000;\n    color: white;\n    width: 100%;\n    text-align: center;\n    padding-top: 2em;\n    padding-bottom: 2em;\n}\n\n#footer-contact {\n    margin-bottom: 0;\n}\n\n#footer-weeloy {\n    margin-top: 0;\n}\n\n#footer-logo {\n    text-align: center;\n}\n\n#footer-logo > img {\n    width: 50px;\n}\n\n#footer-newsletter {\n    margin-top: 1em;\n}\n\n#footer-newsletter-button {\n    background: #981A18;\n    color: #fff;\n    margin-left: 15px;\n    padding: 0 15px;\n    border: 1px solid #fff;\n    font-size: 12px;\n    text-transform: uppercase;\n    font-family: arial;\n}\n\n#footer-newsletter-textfield {\n    color: #ffb97b;\n    font-size: 12px;\n    text-transform: capitalize;\n    font-family: arial;\n    padding: 0 5px;\n    border: none;\n}\n.thetitle{\n    font-family:Dosis!important;\n        font-size: 25px!important;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/kala/Sites/weeloy_website_engine/website-new-template-fun/src/app/footer.component.css
// module id = ../../../../../src/app/footer.component.css
// module chunks = main